import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";
import Footer from "components/Footer/Footer.jsx";
import TopNav from "components/Navigation/TopNav.jsx";

import routes from "../../routes.js";
import Breadcrumbs from "./Breadcrumbs";

import Loading from 'react-loading-bar'
import 'react-loading-bar/dist/index.css'
import {connect} from "react-redux";

import CoreEngine from "../../core/CoreEngine";
import {resetMsg} from "../../core/redux/actions/showMsg";
import { registerPushToken, listenForForegroundPush } from "../../core/pushNotifications";
import { syncSessionFromToken } from "../../core/session";
let ps;

class Admin extends CoreEngine {
  constructor(props) {
    super(props);
    // What the account may do is re-read from the token on every entry into
    // /admin, so a permission change takes effect on the next login instead of
    // never, and a session cannot outlive the token it was opened with.
    if (!syncSessionFromToken() && props.history) {
      props.history.push("/auth/login");
    }
    this.state = {
      backgroundColor: "black",
      activeColor: "info",
    };
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.refs.mainPanel);
    }

    // Reaching /admin at all — a fresh login or an already-active session
    // that just reloaded — means asking for push permission belongs here,
    // not only in Login.jsx. requestPermission() only shows a prompt while
    // permission is still undecided; once granted it just re-registers
    // silently, and once denied this is a no-op (the browser won't re-ask).
    if (window.Notification && Notification.permission !== "denied") {
      registerPushToken();
    }
    listenForForegroundPush();
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
    this.clearStaleOverlays();
  }

  // a dialog that unmounts with the page it belonged to can leave its backdrop
  // in the dom; that invisible layer swallows every click until a reload
  clearStaleOverlays() {
    if (document.querySelector(".modal.show, .modal[style*='display: block']")) {
      return;
    }
    document
      .querySelectorAll(".modal-backdrop")
      .forEach((node) => node.parentNode && node.parentNode.removeChild(node));
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  handleActiveClick = color => {
    this.setState({ activeColor: color });
  };
  handleBgClick = color => {
    this.setState({ backgroundColor: color });
  };





  render() {


    if(this.props.showmsg && this.props.showmsg.type !==0 ){
        this.showalert(this.props.showmsg.msg,this.props.showmsg.type)
    }

    return (
      <div className="wrapper">
          <Loading
              show={this.props.progress.loading}
              color="red"
          />

        <TopNav {...this.props} routes={routes} />
        <div className="main-panel" ref="mainPanel">
            <div className="breadmin"> <Breadcrumbs /></div>

          <Switch>{this.getRoutes(routes)}</Switch>
          {// we don't want the Footer to be rendered on full screen maps page
          this.props.location.pathname.indexOf("full-screen-map") !==
          -1 ? null : (
            <Footer fluid />
          )}
        </div>

      </div>
    );
  }
}


const mapStateToProps = state => ({

    ...state
});

const mapDispatchToProps = dispatch => ({
    resetMsg: () => dispatch(resetMsg()),
});
export default connect(mapStateToProps, mapDispatchToProps)(Admin);
